import React, { useState, useEffect } from 'react'
import { MagnifyingGlass } from 'react-loader-spinner'
import { useLocation } from 'react-router-dom'
import '../../styles/componentsStyles/Browse/BrowseContent.scss'

// File viewer
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import webb from '../../assets/files/web3.pdf'
import Logo from "../../assets/logos/codemmit-logo.png"
import FullScreenView from './FullScreenView';
import BookView from './BookView';
import BrowseImages from './BrowseImages';

// CODE RELATED TO PDF VIEWER 
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// CODE RELATED TO PDF VIEWER (react-pdf) END

const BrowseContent = (props) => {
    const [showDescription, setShowDescription] = useState(false);
    const [showInFullScreen, setShowInFullScreen] = useState(false);
    const [showInBookMode, setShowInBookMode] = useState(false);
    const [contentType, setContentType] = useState("image");

    // PDF VIEWER 
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [showLoader, setShowLoader] = useState(true);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const contentId = queryParams.get('id');
    const fileType = queryParams.get('type');

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setShowLoader(false);
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') {
                if (pageNumber >= 2) { setPageNumber(pageNumber - 1) }
            } else if (event.key === 'ArrowRight') {
                if (pageNumber < numPages) { setPageNumber(pageNumber + 1) }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });

    const toggleDescription = () => {
        if (showDescription === false) {
            setShowDescription(true);
        }
        else {
            setShowDescription(false);
        }
    }

    const handleContentExpand = () => {
        if (showInFullScreen) {
            setShowInFullScreen(false);
        } else {
            setShowInFullScreen(true);
        }
    }


    const handleBookMode = () => {
        if (showInBookMode) {
            setShowInBookMode(false);
        } else {
            setShowInBookMode(true);
        }
    }

    return (
        <>
            <div className='browse-content'>
                <div className={false ? "browse-content__content-container" : "browse-content__content-container-image"}>

                    {
                        contentType === "file" ? <div className="browse-content__content-box">
                            <Document file={webb} wrap={false} onLoadSuccess={onDocumentLoadSuccess} // Revoke data uri after image is loaded
                                className='browse-content__thumbnail'>
                                <Page pageNumber={pageNumber} />
                            </Document>
                            {
                                showLoader && <MagnifyingGlass
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="magnifying-glass-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="magnifying-glass-wrapper"
                                    glassColor="#c0efff"
                                    color="#e15b64"
                                />
                            }
                        </div> : <div className="browse-content__image-content-box">
                            <BrowseImages />
                        </div>
                    }

                    {
                        contentType === "file" && <div className="browse-content__pdf-page-navigation">
                            <div className="browse-content__nav-btn browse-content__nav-btn--prev" onClick={() => { if (pageNumber >= 2) { setPageNumber(pageNumber - 1) } }}><span class="material-symbols-rounded">
                                keyboard_arrow_left
                            </span></div>
                            <p className='browse-content__pdf-page-indicator'>
                                {pageNumber}/{numPages}
                            </p>
                            <div className="browse-content__nav-btn browse-content__nav-btn--next" onClick={() => { if (pageNumber < numPages) { setPageNumber(pageNumber + 1) } }}><span class="material-symbols-rounded">
                                keyboard_arrow_right
                            </span></div>
                        </div>
                    }
                    {
                        contentType === "file" ? <div className="browse-content__content-engagement-actions">
                            <button title="This is a tooltip">
                                <span class="material-symbols-outlined">
                                    thumb_up
                                </span>
                                <p>1.2k</p>
                            </button>
                            <button>
                                <span class="material-symbols-outlined">
                                    visibility
                                </span>
                                <p>10k</p>
                            </button>
                            <button>
                                <span class="material-symbols-outlined">
                                    share
                                </span>
                                <p>Share</p>
                            </button>
                            <button onClick={handleContentExpand}>
                                <span class="material-symbols-outlined">
                                    aspect_ratio
                                </span>
                                <p>Expand</p>
                            </button>
                            <button onClick={handleBookMode}>
                                <span class="material-symbols-outlined"> menu_book </span>
                                <p>Book Mode</p>
                            </button>
                            <button>
                                <span class="material-symbols-rounded">download</span>
                                <p>Download</p>
                            </button>
                        </div> : <div className="browse-content__content-engagement-actions-image">
                            <button title="This is a tooltip">
                                <span class="material-symbols-outlined">
                                    thumb_up
                                </span>
                                <p>1.2k</p>
                            </button>
                            <button>
                                <span class="material-symbols-outlined">
                                    visibility
                                </span>
                                <p>10k</p>
                            </button>
                            <button>
                                <span class="material-symbols-outlined">
                                    share
                                </span>
                                <p>Share</p>
                            </button>
                            <button>
                                <span class="material-symbols-rounded">download</span>
                                <p>Download</p>
                            </button>
                        </div>
                    }

                </div>
                <div className="browse-content__channel-info">
                    <div className="browse-content__channel-logo-container">
                        <div className="browse-content__channel-logo">
                            <img src={Logo} alt="logo" />
                        </div>
                        <div className="browse-content__about">
                            <p>Codemmit</p>
                            <p>Followers &#183; 65K</p>
                        </div>
                    </div>
                    <button className='browse-content__follow-btn'>Follow</button>
                </div>
                <div className="browse-content__post-details">
                    <div className='browse-content__toogle-description-bar' onClick={toggleDescription}>
                        <h4>Description</h4>
                        <button>
                            <span class="material-symbols-outlined">
                                expand_more
                            </span>
                        </button>
                    </div>
                    {
                        showDescription && <p className='browse-content__description'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Debitis laboriosam perspiciatis eaque labore corporis ipsum, voluptatum culpa nulla omnis aliquid? Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iste accusamus porro natus, itaque voluptatibus odio nam quod molestiae amet mollitia ratione voluptate illum doloremque esse.</p>
                    }
                </div>

            </div>
            {
                showInFullScreen && <div className="browse-content__full-screen-view-container">
                    <span className="browse-content__close-full-screen-viewer material-symbols-outlined" onClick={handleContentExpand}>
                        close
                    </span>
                    <FullScreenView file={webb} />
                </div>
            }
            {
                showInBookMode && <div className="browse-content__book-view-container">
                    <span className="browse-content__close-book-view material-symbols-outlined" onClick={handleBookMode}>
                        close
                    </span>
                    <BookView file={webb} />
                </div>
            }
        </>
    )
}

export default BrowseContent